import { createMask } from 'imask';

const mask = createMask({
  mask: '+{7} (000) 000-00-00',
});

export const formatPhone = (rawPhone: string): string => {
  mask.resolve(rawPhone);

  return mask.value;
};
